var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { isFunction } from "lodash";
const useImageSocialAttributes = ({
  src,
  config,
  width,
  height
}) => {
  if (src === void 0 || (config == null ? void 0 : config.imageProps) === void 0) {
    return {};
  }
  const imageProps = isFunction(config.imageProps) ? config.imageProps({ url: src.url, file_name: src.id, width, height }) : config.imageProps;
  return ["data-pin-nopin", "data-pin-url", "data-pin-media"].reduce(
    (socialAttributes, attribute) => {
      if (imageProps[attribute]) {
        return __spreadProps(__spreadValues({}, socialAttributes), { [attribute]: imageProps[attribute] });
      }
      return socialAttributes;
    },
    {}
  );
};
export {
  useImageSocialAttributes
};
//# sourceMappingURL=use-image-social-attributes.js.map
